import axios from "axios";
import React, { useState, useEffect } from "react";
// ...existing code...
import { API_BASE_URL } from "../config/constants";
// ...existing code...


export default function Account() {
  const [userData, setUserData] = useState({});
  const [visible, setVisible] = useState(false);
  const [showChangePwd, setShowChangePwd] = useState(false);
  const [error, setError] = useState("");

  // ...existing code...

  const handleChangePassword = async () => {
    setError("");

    // frontend validation (already done, but keeping safe)
    if (
      !pwdData.oldPassword ||
      !pwdData.newPassword ||
      !pwdData.confirmPassword
    ) {
      setError("All fields are required");
      return;
    }

    if (pwdData.newPassword !== pwdData.confirmPassword) {
      setError("Passwords do not match");
      return;
    }

    try {
      const token = localStorage.getItem("token"); // or wherever you store it
      const deviceId = localStorage.getItem("deviceId"); // same one used during login


      const res = await axios.post(
        `${API_BASE_URL}/change-password`,
        {
          oldPassword: pwdData.oldPassword,
          newPassword: pwdData.newPassword,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "device-id": localStorage.getItem("deviceId"), // now not null

          }

        }
      );


      // success
      alert("Password changed successfully");

      setShowChangePwd(false);
      setPwdData({
        oldPassword: "",
        newPassword: "",
        confirmPassword: "",
      });
    } catch (err) {
      setError(
        err.response?.data?.message || "Failed to change password"
      );
    }
  };



  const [pwdData, setPwdData] = useState({
    oldPassword: "",
    newPassword: "",
    confirmPassword: "",
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
         const stored = localStorage.getItem("state");
          if (stored) {
   const data = JSON.parse(stored);
     const res = await axios.get(`${API_BASE_URL}/get-user/${data.id}`);
    setUserData(res.data);
        }
       
      } catch (err) {
        console.error("Error fetching user data:", err);
      }
    };
    fetchData();
  }, []);

  const getSites = (user) => {
    return user?.sites?.map((s) => s.siteName).join(", ") || "";
  };

  return (

    <div className="min-h-screen text-white pl-[6.75rem]">
      {/* Page Title */}
      <div className="text-[1.333rem] font-semibold not-italic mb-[0.5625rem] mt-[4.5625rem] font-poppins">Account</div>
      <div className="opacity-60 font-poppins font-normal not-italic text-base"></div>

      {/* Profile Card */}
      <div className="relative rounded-xl max-w-4xl">
        <div className="mt-12 font-normal not-italic text-[1.167rem] text-[rgba(103,111,110,1)]">My Profile</div>


        {/* Role */}
        <div className="flex gap-4 mb-[2.625rem] mt-[1.75rem]">
          {/* Profile Picture */}
          <div className="rounded-full flex items-center justify-center">
            <img
              src="/assets/profile-img1.jpg" // replace with your actual dummy image path
              alt="Profile"
              className="w-[4.0625rem] h-[4.0625rem] object-cover rounded-full"
            />
          </div>

          {/* Role Info */}
          <div className="flex flex-col">
            <div className="font-poppins text-[1.333rem] leading-[2rem] font-semibold text-white">
              {userData?.role?.role || userData?.role || "Role"}
            </div>
            <div className="font-poppins font-normal not-italic text-[1.167rem] leading-[1.667rem] text-[#676F6E]">
              User Role
            </div>
          </div>
        </div>



        {/* Information Grid */}
        <div className="w-full max-w-[48rem]">
          {/* Information Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-y-[2.8125rem] mt-6">

            {/* First Name */}
            <div>
              <div className="text-[#676F6E] text-[1.167rem] leading-[1.667rem] font-poppins font-normal not-italic mb-2">
                First Name
              </div>
              <div className="text-[1rem] leading-[2rem] font-normal not-italic">
                {userData.firstName || "-"}
              </div>
            </div>

            {/* Last Name */}
            <div>
              <div className="text-[#676F6E] text-[1.167rem] leading-[1.667rem] mb-2 font-poppins font-normal not-italic">
                Last Name
              </div>
              <div className="text-[1rem] leading-[2rem] font-normal font-poppins not-italic">
                {userData.lastName || "-"}
              </div>
            </div>

            {/* Email */}
            <div>
              <div className="text-[#676F6E] text-[1.167rem] leading-[1.667rem] mb-2 font-poppins font-normal not-italic">
                Email ID
              </div>
              <div className="text-[1rem] leading-[2rem] font-normal font-poppins not-italic">
                {userData.email || "-"}
              </div>
            </div>

            {/* Password */}
            <div>
              <div className="text-[#676F6E] text-[1.167rem] leading-[1.667rem] mb-2 font-poppins font-normal not-italic">
                Password
              </div>
              <div className="text-[1rem] leading-[2rem] mb-2 font-normal font-poppins not-italic">
                {userData.password || "-"}
              </div>
              <button
                onClick={() => setShowChangePwd(true)}
                className="text-[rgba(26,172,157,0.25)] font-poppins text-[1rem] font-normal not-italic leading-[1.667rem]
             hover:text-[#1AAC9D] hover:underline transition-colors duration-200"
              >
                Change Password
              </button>

            </div>
          </div>
        </div>


        {/* Sites */}
        <div className="mt-10">
          <div className="text-[#676F6E] mb-2 text-[1.167rem] leading-[1.667rem] font-poppins font-normal not-italic">Sites</div>
          <div className="text-[1rem] leading-[2rem] font-normal font-poppins not-italic">
            {getSites(userData) || "-"}
          </div>
        </div>
      </div>
      {showChangePwd && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 px-4">
          <div className="relative w-full max-w-[38rem] bg-[#051E1C]/90 backdrop-blur-sm rounded-2xl shadow-2xl px-[5.0625rem] py-[5.5rem]">

            {/* Close Icon */}
            <button
              onClick={() => {
                setShowChangePwd(false);
                setPwdData({
                  oldPassword: "",
                  newPassword: "",
                  confirmPassword: "",
                });
                setError("");
              }}
              className="absolute top-6 right-6 text-white/70 text-xl"
            >
              ✕
            </button>

            {/* Title */}
            <h2 className="text-[2.25rem] font-poppins font-semibold text-white mb-[2.125rem]">
              Change Password
            </h2>

            {/* Old Password */}
            <div className="mb-[2.5rem]">
              <label className="block text-white font-poppins text-[0.875rem] font-normal mb-[0.375rem]">
                Old Password*
              </label>
              <input
                type="password"
                placeholder="Enter old password"
                value={pwdData.oldPassword}
                onChange={(e) =>
                  setPwdData({ ...pwdData, oldPassword: e.target.value })
                }
                className="w-full font-poppins h-[3.4375rem] px-[0.875rem] py-[0.625rem] bg-[#33504D75] text-white focus:border-gray-300 focus:ring-teal-500/50 rounded-lg text-[1rem]"
              />
            </div>

            {/* New Password */}
            <div className="mb-[2.5rem]">
              <label className="block text-white font-poppins text-[0.875rem] font-normal mb-[0.375rem]">
                New Password*
              </label>
              <input
                type="password"
                placeholder="Enter new password"
                value={pwdData.newPassword}
                onChange={(e) =>
                  setPwdData({ ...pwdData, newPassword: e.target.value })
                }
                className="w-full font-poppins h-[3.4375rem] px-[0.875rem] focus:border-gray-300 focus:ring-teal-500/50 py-[0.625rem] bg-[#33504D75] text-white rounded-lg text-[1rem]"
              />
            </div>

            {/* Confirm Password */}
            <div className="mb-[4.8125rem]">
              <label className="block text-white font-poppins text-[0.875rem] font-normal mb-[0.375rem]">
                Confirm New Password*
              </label>
              <input
                type="password"
                placeholder="Re-enter new password"
                value={pwdData.confirmPassword}
                onChange={(e) =>
                  setPwdData({ ...pwdData, confirmPassword: e.target.value })
                }
                className="w-full font-poppins h-[3.4375rem] px-[0.875rem] focus:border-gray-300 focus:ring-teal-500/50 py-[0.625rem] bg-[#33504D75] text-white rounded-lg text-[1rem]"
              />
            </div>

            {/* Error */}
            {error && <p className="text-red-500 text-sm mb-4">{error}</p>}

            {/* Update Button */}
            <button
              onClick={handleChangePassword}
              className="w-full max-w-[26.3125rem] min-h-[3.4375rem] bg-[#147A6F] text-white text-[1.375rem] font-semibold rounded-full mx-auto block"
            >
              Update Password
            </button>
          </div>
        </div>
      )}



    </div>




  );
}
